<template>
  <div class="contact" id="contacto">
    <b-container>
      <b-row align-h="center">
        <b-col md="8">
          <h1 class="font-weight-bold mb-3">
            {{ success ? "Recibimos tu mensaje!" : "Contactanos" }}
          </h1>
          <p class="font-weight-light">Te responderemos a la brevedad.</p>
          <ValidationObserver v-slot="{ handleSubmit }" ref="form" slim>
            <b-form
              class="mt-5"
              novalidate
              @submit.prevent="handleSubmit(submit)"
            >
              <b-row>
                <b-col sm="6">
                  <ValidationProvider
                    name="name"
                    rules="required"
                    v-slot="{ errors }"
                    tag="div"
                    slim
                  >
                    <b-form-input
                      v-model="form.name"
                      placeholder="Nombre completo"
                      id="form-name"
                      name="form-name"
                      :class="[
                        'rounded-0',
                        'mb-3',
                        { 'is-invalid': errors[0] }
                      ]"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="!errors[0]">
                      Debes ingresar tu nombre
                    </b-form-invalid-feedback>
                  </ValidationProvider>
                  <ValidationProvider
                    name="phone"
                    rules="required"
                    v-slot="{ errors }"
                    tag="div"
                    slim
                  >
                    <b-form-input
                      v-model="form.phone"
                      type="tel"
                      placeholder="Teléfono"
                      id="form-phone"
                      name="form-phone"
                      :class="[
                        'rounded-0',
                        'mb-3',
                        { 'is-invalid': errors[0] }
                      ]"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="!errors[0]">
                      Ingresa un número de teléfono
                    </b-form-invalid-feedback>
                  </ValidationProvider>
                  <ValidationProvider
                    name="email"
                    rules="required|email"
                    v-slot="{ errors }"
                    tag="div"
                    slim
                  >
                    <b-form-input
                      v-model="form.email"
                      type="email"
                      placeholder="Email"
                      id="form-email"
                      name="form-email"
                      :class="[
                        'rounded-0',
                        'mb-3',
                        { 'is-invalid': errors[0] }
                      ]"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="!errors[0]">
                      Ups, parece que no has escrito bien el email
                    </b-form-invalid-feedback>
                  </ValidationProvider>
                  <ValidationProvider
                    name="service"
                    rules="required"
                    v-slot="{ errors }"
                    tag="div"
                    slim
                  >
                    <b-form-select
                      v-model="form.service"
                      :options="serviceOptions"
                      id="form-service"
                      name="form-service"
                      :class="['rounded-0', { 'is-invalid': errors[0] }]"
                    ></b-form-select>
                    <b-form-invalid-feedback :state="!errors[0]">
                      Selecciona uno de los servicios
                    </b-form-invalid-feedback>
                  </ValidationProvider>
                </b-col>
                <b-col
                  sm="6"
                  class="pt-3 pt-sm-0 d-sm-flex flex-column align-items-end"
                >
                  <ValidationProvider
                    name="message"
                    rules="required"
                    v-slot="{ errors }"
                    tag="div"
                    class="w-100"
                    slim
                  >
                    <b-form-textarea
                      v-model="form.message"
                      placeholder="Escribe tu consulta aquí"
                      id="form-message"
                      name="form-message"
                      rows="5"
                      no-resize
                      style="height: 146px;"
                      :class="['rounded-0', { 'is-invalid': errors[0] }]"
                    ></b-form-textarea>
                    <b-form-invalid-feedback :state="!errors[0]">
                      Ingresa tu consulta
                    </b-form-invalid-feedback>
                  </ValidationProvider>
                  <div class="ml-auto mt-3">
                    <b-overlay
                      :show="loading"
                      opacity="0.6"
                      spinner-small
                      spinner-variant="light"
                      class="d-inline-block"
                    >
                      <b-button
                        class="px-4 rounded-0 bg-color-darken-1"
                        type="submit"
                      >
                        {{ success ? "Enviado" : "Enviar" }}
                      </b-button>
                    </b-overlay>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </ValidationObserver>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { db } from "@/services/firebase";
import emailjs from "emailjs-com";

extend("required", required);
extend("email", email);

export default {
  name: "Contact",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      form: {
        name: "",
        phone: "",
        email: "",
        // subject: "",
        service: null,
        message: ""
      },
      serviceOptions: [
        { value: null, disabled: true, text: "Servicio" },
        { value: "Estudios previos", text: "Estudios previos" },
        { value: "Anteproyecto", text: "Anteproyecto" },
        { value: "Proyecto legal", text: "Proyecto legal" },
        { value: "Proyecto ejecutivo", text: "Proyecto ejecutivo" },
        { value: "Dirección técnica", text: "Dirección técnica" },
        { value: "Administración de obra", text: "Administración de obra" },
        { value: "Asesoramiento", text: "Asesoramiento" },
        { value: "Otro servicio", text: "Otro servicio" }
      ],
      success: false,
      loading: false
    };
  },
  methods: {
    async submit() {
      this.loading = true;
      await db.collection("leads").doc().set(this.form);

      emailjs
        .send(
          "don_web_ui_names",
          "template_birpYSV4",
          this.form,
          "user_eAUQfsovcQCV0e2B7pxYS"
        )
        .then((result) => {
          // console.log("SUCCESS!", result.status, result.text);
          this.loading = false;

          setTimeout(() => {
            this.success = true;
          }, 500);

          this.clearForm();

          this.$nextTick(() => {
            this.$refs.form.reset();
          });

          setTimeout(() => {
            this.success = false;
          }, 4000);
        });
    },
    clearForm() {
      this.form = {
        name: "",
        phone: "",
        email: "",
        // subject: "",
        service: null,
        message: ""
      };
    }
  }
};
</script>

<style scoped lang="sass">
.contact
  margin: 6rem 0
  @media screen and (max-width: 502px)
    padding: 0 1rem
    text-align: center
  .is-invalid
    margin-bottom: 0 !important
    & + .invalid-feedback
      margin-bottom: 1rem
  .form-control, .custom-select
    border: 1px solid #efefef
</style>
